import React from "react";
import English from "../../components/LKG/English";
import EnglishMenu from "./English";
import Mathematics from "../../components/LKG/Mathematics";
import MathematicsMenu from "./Mathematics";
import GeneralAwareness from "../../components/LKG/GeneralAwareness";
import GeneralAwarenessMenu from "./GeneralAwareness";
import EnvironmentScience from "../../components/LKG/EnvironmentScience";
import EnvironmentScienceMenu from "./EnvironmentScience";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; 
    subMenu?: MenuItem[]; 
}

// Define ClassTwoMenu with the proper type
const LKGMenu: MenuItem[] = [
    { 
        url: "/lkg/english-language", 
        title: "English Language",
        component: English,
        subMenu: EnglishMenu
    },
    { 
        url: "/lkg/mathematics", 
        title: "Mathematics",
        component: Mathematics,
        subMenu: MathematicsMenu
    },
    { 
        url: "/lkg/environmental-science", 
        title: "Environmental Science (EVS)", 
        component: EnvironmentScience,
        subMenu: EnvironmentScienceMenu
    },
    { 
        url: "/lkg/general-awareness", 
        title: "General Awareness", 
        component: GeneralAwareness,
        subMenu: GeneralAwarenessMenu
    }
];

export default LKGMenu;

